import data from "../../.sourceflow/dei_offerings.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const offerings_helper = new CollectionHelper(data);
